// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statement-summary-grid[data-v-7774fae6] .ag-row{overflow:visible !important;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}", ""]);
// Exports
module.exports = exports;
